class LocalStorage {
	static remove = (key) => {
		window.localStorage.removeItem(key);
	};

	static set = (key, value) => {
		window.localStorage.setItem(key, JSON.stringify(value));
	};

	static get = (key) => {
		const value = window.localStorage.getItem(key);
		if (!value) {
			return null;
		}
		return JSON.parse(value);
	};

	static getToken = () => {
		return LocalStorage.get("token");
	};
}

export default LocalStorage;
